export const APIUrlStrings = {
  sendRequestToDeletePharamcy: "/delete-pharmacy-request/",
  sendEnquirywebsiteDemo: "/enquiry-website",
};
